import styled from "styled-components";

interface SpacerProps {
	size: number;
}

export const Spacer = styled.div<SpacerProps>`
	width: 100%;
	height: ${props => (props.size ? props.size : 0)}px;
`;
